import { isEmpty, find, filter } from 'lodash'

const initialState = {
  isFetchingFL142Data: false,

  isFetchingRealEstate: false,
  isFetchingHouseHold: false,
  isFetchingJewelary: false,
  isFetchingVehicles: false,
  isFetchingSavings: false,
  isFetchingChecking: false,
  isFetchingCredit: false,
  isFetchingCash: false,
  isFetchingTaxRefund: false,
  isFetchingLifeInsurance: false,
  isFetchingStocks: false,
  isFetchingRetirements: false,
  isFetchingProfit: false,
  isFetchingAccounts: false,
  isFetchingPartnership: false,
  isFetchingOtherAssets: false,
  isFetchingContinuationAssets: false,

  isFetchingDeleteFL142Assets: false,
  isFetchingDeleteFL142Debits: false,

  isFetchingDescriptionData: false,
  descriptionOption: [],
  isFetchingSecondTableFL142Data: false,

  isFetchingStudentLoans: false,
  isFetchingTaxes: false,
  isFetchingSupport: false,
  isFetchingLoans: false,
  isFetchingCreditCards: false,
  isFetchingDebts: false,
  isFetchingContinuationDebts: false,

  isFetchingFL142GetData: false,

  realEstate: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  household: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  jewelary: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  vehicles: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  savings: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  checking: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  credit: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  cash: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  taxRefund: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  lifeInsurance: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  stocks: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  retirements: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  profit: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  accounts: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  partnership: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  otherAssets: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  continuationAssets: [{
    asset_description: '',
    asset_sep_prop: '',
    asset_date_acquired: '',
    asset_cgfmv: '0.0',
    asset_amoe: '0.0',
  }],

  studentLoans: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  taxes: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  support: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  loans: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  creditCards: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  debts: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],

  continuationDebts: [{
    debt_description: '',
    debt_sep_prop: '',
    total_owing: '0.0',
    debt_date_incurred: '',
  }],
};

const fl142Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_POST_FL_142":
      return { ...state, isFetchingFL142Data: true };
    case "SUCCESS_POST_FL_142":
      return { ...state, isFetchingFL142Data: false };
    case "ERROR_POST_FL_142":
      return { ...state, isFetchingFL142Data: false };

    case "REQUEST_FL_142_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: true };
    case "SUCCESS_FL_142_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false, realEstate: action.payload.data };
    case "ERROR_FL_142_REAL_ESTATE":
      return { ...state, isFetchingRealEstate: false };

    case "REQUEST_FL_142_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: true };
    case "SUCCESS_FL_142_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false, household: action.payload.data };
    case "ERROR_FL_142_HOUSE_HOLD":
      return { ...state, isFetchingHouseHold: false };

    case "REQUEST_FL_142_JEWELARY":
      return { ...state, isFetchingJewelary: true };
    case "SUCCESS_FL_142_JEWELARY":
      return { ...state, isFetchingJewelary: false, jewelary: action.payload.data };
    case "ERROR_FL_142_JEWELARY":
      return { ...state, isFetchingJewelary: false };

    case "REQUEST_FL_142_VEHICLES":
      return { ...state, isFetchingVehicles: true };
    case "SUCCESS_FL_142_VEHICLES":
      return { ...state, isFetchingVehicles: false, vehicles: action.payload.data };
    case "ERROR_FL_142_VEHICLES":
      return { ...state, isFetchingVehicles: false };

    case "REQUEST_FL_142_SAVINGS":
      return { ...state, isFetchingSavings: true };
    case "SUCCESS_FL_142_SAVINGS":
      return { ...state, isFetchingSavings: false, savings: action.payload.data };
    case "ERROR_FL_142_SAVINGS":
      return { ...state, isFetchingSavings: false };

    case "REQUEST_FL_142_CHECKING":
      return { ...state, isFetchingChecking: true };
    case "SUCCESS_FL_142_CHECKING":
      return { ...state, isFetchingChecking: false, checking: action.payload.data };
    case "ERROR_FL_142_CHECKING":
      return { ...state, isFetchingChecking: false };

    case "REQUEST_FL_142_CREDIT":
      return { ...state, isFetchingCredit: true };
    case "SUCCESS_FL_142_CREDIT":
      return { ...state, isFetchingCredit: false, credit: action.payload.data };
    case "ERROR_FL_142_CREDIT":
      return { ...state, isFetchingCredit: false };

    case "REQUEST_FL_142_CASH":
      return { ...state, isFetchingCash: true };
    case "SUCCESS_FL_142_CASH":
      return { ...state, isFetchingCash: false, cash: action.payload.data };
    case "ERROR_FL_142_CASH":
      return { ...state, isFetchingCash: false };

    case "REQUEST_FL_142_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: true };
    case "SUCCESS_FL_142_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false, taxRefund: action.payload.data };
    case "ERROR_FL_142_TAX_REFUND":
      return { ...state, isFetchingTaxRefund: false };

    case "REQUEST_FL_142_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: true };
    case "SUCCESS_FL_142_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false, lifeInsurance: action.payload.data };
    case "ERROR_FL_142_LIFE_INSURANCE":
      return { ...state, isFetchingLifeInsurance: false };

    case "REQUEST_FL_142_STOCKS":
      return { ...state, isFetchingStocks: true };
    case "SUCCESS_FL_142_STOCKS":
      return { ...state, isFetchingStocks: false, stocks: action.payload.data };
    case "ERROR_FL_142_STOCKS":
      return { ...state, isFetchingStocks: false };

    case "REQUEST_FL_142_RETIREMENTS":
      return { ...state, isFetchingRetirements: true };
    case "SUCCESS_FL_142_RETIREMENTS":
      return { ...state, isFetchingRetirements: false, retirements: action.payload.data };
    case "ERROR_FL_142_RETIREMENTS":
      return { ...state, isFetchingRetirements: false };

    case "REQUEST_FL_142_PROFIT":
      return { ...state, isFetchingProfit: true };
    case "SUCCESS_FL_142_PROFIT":
      return { ...state, isFetchingProfit: false, profit: action.payload.data };
    case "ERROR_FL_142_PROFIT":
      return { ...state, isFetchingProfit: false };

    case "REQUEST_FL_142_ACCOUNTS":
      return { ...state, isFetchingAccounts: true };
    case "SUCCESS_FL_142_ACCOUNTS":
      return { ...state, isFetchingAccounts: false, accounts: action.payload.data };
    case "ERROR_FL_142_ACCOUNTS":
      return { ...state, isFetchingAccounts: false };

    case "REQUEST_FL_142_PARTNERSHIP":
      return { ...state, isFetchingPartnership: true };
    case "SUCCESS_FL_142_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false, partnership: action.payload.data };
    case "ERROR_FL_142_PARTNERSHIP":
      return { ...state, isFetchingPartnership: false };

    case "REQUEST_FL_142_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: true };
    case "SUCCESS_FL_142_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false, otherAssets: action.payload.data };
    case "ERROR_FL_142_OTHER_ASSETS":
      return { ...state, isFetchingOtherAssets: false };

    case "REQUEST_FL_142_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: true };
    case "SUCCESS_FL_142_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false, continuationAssets: action.payload.data };
    case "ERROR_FL_142_CONTINUATION_ASSETS":
      return { ...state, isFetchingContinuationAssets: false };

    case "REQUEST_GET_FL_142":
      return { ...state, isFetchingDescriptionData: true };
    case "SUCCESS_GET_FL_142":
      return { ...state, descriptionOption: action.payload, isFetchingDescriptionData: false };
    case "ERROR_GET_FL_142":
      return { ...state, isFetchingDescriptionData: false };

    case "REQUEST_POST_SECOND_TABLE_FL_142":
      return { ...state, isFetchingSecondTableFL142Data: true };
    case "SUCCESS_POST_SECOND_TABLE_FL_142":
      return { ...state, isFetchingSecondTableFL142Data: false };
    case "ERROR_POST_SECOND_TABLE_FL_142":
      return { ...state, isFetchingSecondTableFL142Data: false };

    case "REQUEST_FL_142_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: true };
    case "SUCCESS_FL_142_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false, studentLoans: action.payload.data };
    case "ERROR_FL_142_STUDENT_LOANS":
      return { ...state, isFetchingStudentLoans: false };

    case "REQUEST_FL_142_TAXES":
      return { ...state, isFetchingTaxes: true };
    case "SUCCESS_FL_142_TAXES":
      return { ...state, isFetchingTaxes: false, taxes: action.payload.data };
    case "ERROR_FL_142_TAXES":
      return { ...state, isFetchingTaxes: false };

    case "REQUEST_FL_142_SUPPORT":
      return { ...state, isFetchingSupport: true };
    case "SUCCESS_FL_142_SUPPORT":
      return { ...state, isFetchingSupport: false, support: action.payload.data };
    case "ERROR_FL_142_SUPPORT":
      return { ...state, isFetchingSupport: false };

    case "REQUEST_FL_142_LOANS":
      return { ...state, isFetchingLoans: true };
    case "SUCCESS_FL_142_LOANS":
      return { ...state, isFetchingLoans: false, loans: action.payload.data };
    case "ERROR_FL_142_LOANS":
      return { ...state, isFetchingLoans: false };

    case "REQUEST_FL_142_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: true };
    case "SUCCESS_FL_142_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false, creditCards: action.payload.data };
    case "ERROR_FL_142_CREDIT_CARDS":
      return { ...state, isFetchingCreditCards: false };

    case "REQUEST_FL_142_DEBTS":
      return { ...state, isFetchingDebts: true };
    case "SUCCESS_FL_142_DEBTS":
      return { ...state, isFetchingDebts: false, debts: action.payload.data };
    case "ERROR_FL_142_DEBTS":
      return { ...state, isFetchingDebts: false };

    case "REQUEST_FL_142_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: true };
    case "SUCCESS_FL_142_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false, continuationDebts: action.payload.data };
    case "ERROR_FL_142_CONTINUATION_DEBTS":
      return { ...state, isFetchingContinuationDebts: false };



    case "REQUEST_FL_142_GET_DATA":
      return { ...state, isFetchingFL142Data: false,

        isFetchingRealEstate: false,
        isFetchingHouseHold: false,
        isFetchingJewelary: false,
        isFetchingVehicles: false,
        isFetchingSavings: false,
        isFetchingChecking: false,
        isFetchingCredit: false,
        isFetchingCash: false,
        isFetchingTaxRefund: false,
        isFetchingLifeInsurance: false,
        isFetchingStocks: false,
        isFetchingRetirements: false,
        isFetchingProfit: false,
        isFetchingAccounts: false,
        isFetchingPartnership: false,
        isFetchingOtherAssets: false,
        isFetchingContinuationAssets: false,
      
        isFetchingDescriptionData: false,
        descriptionOption: [],
        isFetchingSecondTableFL142Data: false,
      
        isFetchingStudentLoans: false,
        isFetchingTaxes: false,
        isFetchingSupport: false,
        isFetchingLoans: false,
        isFetchingCreditCards: false,
        isFetchingDebts: false,
        isFetchingContinuationDebts: false,
      
        isFetchingFL142GetData: true,
      
        realEstate: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        household: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        jewelary: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        vehicles: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        savings: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        checking: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        credit: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        cash: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        taxRefund: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        lifeInsurance: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        stocks: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        retirements: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        profit: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        accounts: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        partnership: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        otherAssets: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        continuationAssets: [{
          asset_description: '',
          asset_sep_prop: '',
          asset_date_acquired: '',
          asset_cgfmv: '0.0',
          asset_amoe: '0.0',
        }],
      
        studentLoans: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        taxes: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        support: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        loans: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        creditCards: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        debts: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }],
      
        continuationDebts: [{
          debt_description: '',
          debt_sep_prop: '',
          total_owing: '0.0',
          debt_date_incurred: '',
        }]};
    case "SUCCESS_FL_142_GET_DATA":
      return {
        ...state, isFetchingFL142GetData: false,

        realEstate: isEmpty(find(action.payload.data, { "asset_brief_description_id": 1 }).data) ? state.realEstate : find(action.payload.data, { "asset_brief_description_id": 1 }).data,
        household: isEmpty(find(action.payload.data, { "asset_brief_description_id": 2 }).data) ? state.household : find(action.payload.data, { "asset_brief_description_id": 2 }).data,
        jewelary: isEmpty(find(action.payload.data, { "asset_brief_description_id": 3 }).data) ? state.jewelary : find(action.payload.data, { "asset_brief_description_id": 3 }).data,
        vehicles: isEmpty(find(action.payload.data, { "asset_brief_description_id": 4 }).data) ? state.vehicles : find(action.payload.data, { "asset_brief_description_id": 4 }).data,
        savings: isEmpty(find(action.payload.data, { "asset_brief_description_id": 5 }).data) ? state.savings : find(action.payload.data, { "asset_brief_description_id": 5 }).data,
        checking: isEmpty(find(action.payload.data, { "asset_brief_description_id": 6 }).data) ? state.checking : find(action.payload.data, { "asset_brief_description_id": 6 }).data,
        credit: isEmpty(find(action.payload.data, { "asset_brief_description_id": 7 }).data) ? state.credit : find(action.payload.data, { "asset_brief_description_id": 7 }).data,
        cash: isEmpty(find(action.payload.data, { "asset_brief_description_id": 8 }).data) ? state.cash : find(action.payload.data, { "asset_brief_description_id": 8 }).data,
        taxRefund: isEmpty(find(action.payload.data, { "asset_brief_description_id": 9 }).data) ? state.taxRefund : find(action.payload.data, { "asset_brief_description_id": 9 }).data,
        lifeInsurance: isEmpty(find(action.payload.data, { "asset_brief_description_id": 10 }).data) ? state.lifeInsurance : find(action.payload.data, { "asset_brief_description_id": 10 }).data,
        stocks: isEmpty(find(action.payload.data, { "asset_brief_description_id": 11 }).data) ? state.stocks : find(action.payload.data, { "asset_brief_description_id": 11 }).data,
        retirements: isEmpty(find(action.payload.data, { "asset_brief_description_id": 12 }).data) ? state.retirements : find(action.payload.data, { "asset_brief_description_id": 12 }).data,
        profit: isEmpty(find(action.payload.data, { "asset_brief_description_id": 13 }).data) ? state.profit : find(action.payload.data, { "asset_brief_description_id": 13 }).data,
        accounts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 14 }).data) ? state.accounts : find(action.payload.data, { "asset_brief_description_id": 14 }).data,
        partnership: isEmpty(find(action.payload.data, { "asset_brief_description_id": 15 }).data) ? state.partnership : find(action.payload.data, { "asset_brief_description_id": 15 }).data,
        otherAssets: isEmpty(find(action.payload.data, { "asset_brief_description_id": 16 }).data) ? state.otherAssets : find(action.payload.data, { "asset_brief_description_id": 16 }).data,
        continuationAssets: isEmpty(find(action.payload.data, { "asset_brief_description_id": 17 }).data) ? state.continuationAssets : find(action.payload.data, { "asset_brief_description_id": 17 }).data,
        studentLoans: isEmpty(find(action.payload.data, { "asset_brief_description_id": 18 }).data) ? state.studentLoans : find(action.payload.data, { "asset_brief_description_id": 18 }).data,
        taxes: isEmpty(find(action.payload.data, { "asset_brief_description_id": 19 }).data) ? state.taxes : find(action.payload.data, { "asset_brief_description_id": 19 }).data,
        support: isEmpty(find(action.payload.data, { "asset_brief_description_id": 20 }).data) ? state.support : find(action.payload.data, { "asset_brief_description_id": 20 }).data,
        loans: isEmpty(find(action.payload.data, { "asset_brief_description_id": 21 }).data) ? state.loans : find(action.payload.data, { "asset_brief_description_id": 21 }).data,
        creditCards: isEmpty(find(action.payload.data, { "asset_brief_description_id": 22 }).data) ? state.creditCards : find(action.payload.data, { "asset_brief_description_id": 22 }).data,
        debts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 23 }).data) ? state.debts : find(action.payload.data, { "asset_brief_description_id": 23 }).data,
        continuationDebts: isEmpty(find(action.payload.data, { "asset_brief_description_id": 24 }).data) ? state.continuationDebts : find(action.payload.data, { "asset_brief_description_id": 24 }).data,

      };
    case "ERROR_FL_142_GET_DATA":
      return { ...state, isFetchingFL142GetData: false };



      case "REQUEST_DELETE_FL142_ASSETS":
        return { ...state, isFetchingDeleteFL142Assets: true };
      case "SUCCESS_DELETE_FL142_ASSETS":
        console.log(action.payload.data,"reducerdataaaaaaaa")
        return {
          ...state,
          isFetchingDeleteFL142Assets: false,
          realEstate: isEmpty(filter(action.payload.data, {asset_brief_description_id: 1})) ? state.realEstate : filter(action.payload.data, {asset_brief_description_id: 1}),
          household: isEmpty(filter(action.payload.data, {asset_brief_description_id: 2})) ? state.household : filter(action.payload.data, {asset_brief_description_id: 2}),
          jewelary: isEmpty(filter(action.payload.data, {asset_brief_description_id: 3})) ? state.jewelary : filter(action.payload.data, {asset_brief_description_id: 3}),
          vehicles: isEmpty(filter(action.payload.data, {asset_brief_description_id: 4})) ? state.vehicles : filter(action.payload.data, {asset_brief_description_id: 4}),
          savings: isEmpty(filter(action.payload.data, {asset_brief_description_id: 5})) ? state.savings : filter(action.payload.data, {asset_brief_description_id: 5}),
          checking: isEmpty(filter(action.payload.data, {asset_brief_description_id: 6})) ? state.checking : filter(action.payload.data, {asset_brief_description_id: 6}),
          credit: isEmpty(filter(action.payload.data, {asset_brief_description_id: 7})) ? state.credit : filter(action.payload.data, {asset_brief_description_id: 7}),
          cash: isEmpty(filter(action.payload.data, {asset_brief_description_id: 8})) ? state.cash : filter(action.payload.data, {asset_brief_description_id: 8}),
          taxRefund: isEmpty(filter(action.payload.data, {asset_brief_description_id: 9})) ? state.taxRefund : filter(action.payload.data, {asset_brief_description_id: 9}),
          lifeInsurance: isEmpty(filter(action.payload.data, {asset_brief_description_id: 10})) ? state.lifeInsurance : filter(action.payload.data, {asset_brief_description_id: 10}),
          stocks: isEmpty(filter(action.payload.data, {asset_brief_description_id: 11})) ? state.stocks : filter(action.payload.data, {asset_brief_description_id: 11}),
          retirements: isEmpty(filter(action.payload.data, {asset_brief_description_id: 12})) ? state.retirements : filter(action.payload.data, {asset_brief_description_id: 12}),
          profit: isEmpty(filter(action.payload.data, {asset_brief_description_id: 13})) ? state.profit : filter(action.payload.data, {asset_brief_description_id: 13}),
          accounts: isEmpty(filter(action.payload.data, {asset_brief_description_id: 14})) ? state.accounts : filter(action.payload.data, {asset_brief_description_id: 14}),
          partnership: isEmpty(filter(action.payload.data, {asset_brief_description_id: 15})) ? state.partnership : filter(action.payload.data, {asset_brief_description_id: 15}),
          otherAssets: isEmpty(filter(action.payload.data, {asset_brief_description_id: 16})) ? state.otherAssets : filter(action.payload.data, {asset_brief_description_id: 16}),
        };
        
      case "ERROR_DELETE_FL142_ASSETS":
        return { ...state, isFetchingDeleteFL142Assets: false };


        case "REQUEST_DELETE_FL142_DEBITS":
        return { ...state, isFetchingDeleteFL142Debits: true };
      case "SUCCESS_DELETE_FL142_DEBITS":
        return {
          ...state,
          isFetchingDeleteFL142Debits: false,

          studentLoans: isEmpty(filter(action.payload.data, {asset_brief_description_id: 18})) ? state.studentLoans : filter(action.payload.data, {asset_brief_description_id: 18}),
          taxes: isEmpty(filter(action.payload.data, {asset_brief_description_id: 19})) ? state.taxes : filter(action.payload.data, {asset_brief_description_id: 19}),
          support: isEmpty(filter(action.payload.data, {asset_brief_description_id: 20})) ? state.support : filter(action.payload.data, {asset_brief_description_id: 20}),
          loans: isEmpty(filter(action.payload.data, {asset_brief_description_id: 21})) ? state.loans : filter(action.payload.data, {asset_brief_description_id: 21}),
          creditCards: isEmpty(filter(action.payload.data, {asset_brief_description_id: 22})) ? state.creditCards : filter(action.payload.data, {asset_brief_description_id: 22}),
          debts: isEmpty(filter(action.payload.data, {asset_brief_description_id: 23})) ? state.debts : filter(action.payload.data, {asset_brief_description_id: 23}),
        };
      case "ERROR_DELETE_FL142_DEBITS":
        return { ...state, isFetchingDeleteFL142Debits: false };


    default:
      return state;
  }

}


export default fl142Reducer;
